import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectLocationPlanCameraModel } from '../store/models/project-location-plan-camera.model';
import { api } from '../consts/url';

@Injectable({ providedIn: 'root' })
export class ProjectLocationPlanCameraService {
  private readonly http = inject(HttpClient);

  public getAll(projectId: string): Observable<
    ProjectLocationPlanCameraModel.PlanCameraDocument[]
  > {
    return this.http.get<ProjectLocationPlanCameraModel.PlanCameraDocument[]>(api.project.camera.crud(projectId))
  }

  public updateMany(
    projectId: string,
    cameras: ProjectLocationPlanCameraModel.API.BulkUpdateCameraDto,
  ): Observable<boolean> {
    return this.http.put<boolean>(api.project.camera.bulkUpdate(projectId), cameras);
  }

  public updateOne(
    cameraId: string,
    changes: ProjectLocationPlanCameraModel.API.UpdatePlanCameraDto,
  ): Observable<ProjectLocationPlanCameraModel.PlanCameraDocument> {
    return this.http.put<ProjectLocationPlanCameraModel.PlanCameraDocument>(api.project.camera.crudById(cameraId), { ...changes })
  }

  public getPlanCameras(
    projectId: string,
    locationId: string,
    planId: string,
  ): Observable<ProjectLocationPlanCameraModel.PlanCameraDocument[]> {
    return this.http.get<ProjectLocationPlanCameraModel.PlanCameraDocument[]>(
      api.project.camera.crudByIds(projectId, locationId, planId)
    );
  }

  public saveCamera(
    projectId: string,
    locationId: string,
    planId: string,
    cameraData: ProjectLocationPlanCameraModel.API.CreatePlanCameraDto
  ): Observable<ProjectLocationPlanCameraModel.PlanCameraDocument> {
    return this.http.post<ProjectLocationPlanCameraModel.PlanCameraDocument>(
      api.project.camera.crudByIds(projectId, locationId, planId), { ...cameraData }
    );
  }

  public copyCamera(
    cameraId: string,
  ): Observable<ProjectLocationPlanCameraModel.PlanCameraDocument> {
    return this.http.post<ProjectLocationPlanCameraModel.PlanCameraDocument>(
      api.project.camera.copyCamera(cameraId), {}
    );
  }

  public deleteCamera(
    cameraId: string,
  ): Observable<ProjectLocationPlanCameraModel.PlanCameraDocument> {
    return this.http.delete<ProjectLocationPlanCameraModel.PlanCameraDocument>(
      api.project.camera.crudById(cameraId)
    );
  }

  public bulkDelete(
    projectId: string,
    cameraIds: string[],
  ): Observable<boolean> {
    return this.http.delete<boolean>(
      api.project.camera.bulkDelete(projectId),
      {
        body: {
          cameraIds,
        },
      },
    );
  }

  public bulkCreate(
    projectId: string,
    cameras: ProjectLocationPlanCameraModel.API.BulkCreateCameraDto[],
  ): Observable<ProjectLocationPlanCameraModel.PlanCameraDocument[]> {
    return this.http.post<ProjectLocationPlanCameraModel.PlanCameraDocument[]>(
      api.project.camera.bulkCreate(projectId),
      {
        cameras
      },
    );
  }
}

